import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ConfigurationService } from '../../services/configuration.service';
import { LoggerService } from "../../../shared/services/logger.service";
import { CommonService } from "../../../shared/services/common.service";

@Component({
  selector: 'log-file-viewer',
  templateUrl: './log-file-viewer.component.html',
  styleUrls: ['./log-file-viewer.component.scss'],
  standalone: true,
  imports: [
    CdkDrag,
    CdkDragHandle,
    MatDialogTitle,
    MatDialogActions,
    MatFormField,
    MatSelectModule,
    MatButtonModule
  ]
})
export class LogFileViewerComponent implements OnInit, AfterViewChecked
{
  logs: string = '';
  @ViewChild('logContainer') logContainer!: ElementRef;
  private shouldScroll: boolean = false;

  public logFileValue = 0;
  public isPurging = false;

  constructor(
    private commonService: CommonService,
    private loggerService: LoggerService,
    private configurationService: ConfigurationService,
    private http: HttpClient,
    private dialogRef: MatDialogRef<LogFileViewerComponent>
  ) { }

  ngOnInit()
  {
    this.loadLogFile("CampaignBoss.log");
  }

  ngAfterViewChecked()
  {
    if (this.shouldScroll)
    {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  loadLogFile(filename: string)
  {
    // Adjust the path to your log file location
    this.http.get(`${this.configurationService.cbSettings().loggingApiUrl}/GetLog?logfileName=${filename}`, { responseType: 'text' })
      .subscribe({
        next: (data) =>
        {
          this.logs = data;
          this.shouldScroll = true; // Trigger scroll after content updates
        },
        error: (error) =>
        {
          console.error('Error loading log file:', error);
          this.logs = 'Failed to load log file';
          this.shouldScroll = true;
        }
      });
  }

  scrollToBottom()
  {
    if (this.logContainer)
    {
      const element = this.logContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
    }
  }

  onCloseClick(): void
  {
    this.dialogRef.close();
  }

  currentBaseFilename(): string
  {
    switch (this.logFileValue)
    {
      case 0: return 'CampaignBoss.log';
      case 1: return 'CbMaintenance.log';
      default: return 'CampaignBoss.log';
    }
  }

  logFileChange(event: any)
  {
    this.loadLogFile(this.currentBaseFilename());
  }


  purgeArchived()
  {
    this.isPurging = true;
    const baseFile = this.currentBaseFilename();

    this.http.delete<any>(`${this.configurationService.cbSettings().loggingApiUrl}/DeleteArchivedLogs?logfileName=${baseFile}`)
      .subscribe({
        next: (result) =>
        {
          this.isPurging = false;

          if (result.IsSuccessful)
          {
            this.commonService.notifySuccess("Purge complete", result.Message);
          }
          else
          {
            let errMsg = "Unable to purge archived log files.";

            if (result.ErrorMessage)
            {
              errMsg = result.ErrorMessage;
            }

            this.commonService.notifyFailure("Error", errMsg, result.ExceptionMessage, result.ValidationExceptionMessage);
          }

          // Reload current base file content
          this.loadLogFile(baseFile);
        },
        error: (error) =>
        {
          console.error('Error purging archived logs', error);

          this.commonService.notifyFailure("Error", error.message + "  Failed to purge archived logs.", null, null);
          this.loggerService.error(error.message + "  Failed to purge archived logs.");
          this.isPurging = false;
        }
      });
  }





















}
